export default __webpack_public_path__ + "static/media/Term Life to Age 121_5Star_Brochure Guide (1) (1).e8e57957.pdf";